import { getMaster } from "utils/api";

export const fetchMerchantProfile = async (merchantId) => {
  return await getMaster(
    "/merchant-profile/get-merchant-profile?merchantId=" + merchantId,
  );
};
